// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionSettings_container__3co3X","symbolInfo":"SessionSettings_symbolInfo__3F_-i","value":"SessionSettings_value__1pl4m"};